module.exports = __webpack_public_path__ + "static/media/logoArabe.9a76db81.png";